export const INITIAL_SIZE = { width: 550, height: 200 };
export const MAX_SIZE = { width: 1024, height: 1024 };
export const MIN_SIZE = { width: 580, height: 200 };
export const TITLEBAR_HEIGHT = 48;
